import { setClearCacheAPI } from "../api";

export default {
  namespaced: true,
  state: {
    data: {},
  },
  getters: {},

  actions: {
    setClearCache({ dispatch }, payload) {
      const { option, form } = payload;
      dispatch("generalPersist/setToken", form.token, { root: true });
      return new Promise((resolve, reject) => {
        setClearCacheAPI(option, form).then(
          (response) => {
            resolve(response);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      });
    },
  },

  mutations: {},
};
